<template>
  <div>
    <div class="cat-name">
      日活明细<span class="info-text">（每日平台使用用户数）</span>
    </div>
    <div class="search-header">
      <div class="fil-view">
        <div
          :class="['sel-btn', actDay === 1 ? 'active' : '']"
          @click="dayChange(1)"
        >
          7日
        </div>
        <div
          :class="['sel-btn', actDay === 2 ? 'active' : '']"
          @click="dayChange(2)"
        >
          30日
        </div>
        <div>
          <el-form :inline="true" :model="filters" :size="size">
            <el-form-item class="m-l-14">
              <el-date-picker
                v-model="dateArea"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions1"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <butn
                btntype="primary"
                title="查询"
                @click.native="initData"
              ></butn>
              <butn
                btntype="primary"
                title="导出"
                @click.native="exportTable"
                v-permission="'activityStatistics:exportDay'"
              ></butn>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="logo-tip">
        <div class="tip-item" v-for="(item, idx) in tipList" :key="idx">
          <TipLogo :bgColor="item.color" />
          <div class="tip-char">{{ item.name }}</div>
        </div>
      </div>
    </div>

    <div class="mar-30" id="day-active"></div>

    <div class="table-view">
      <div class="left">
        <div class="top fix-item row-title">指标</div>
        <div class="fix-item row-title">APP日活跃度</div>
        <div class="fix-item row-title">web门户日活跃度</div>
        <div class="fix-item row-title">浙政钉小程序日活跃度</div>
        <div class="fix-item row-title">浙政钉PC端日活跃度</div>
        <div class="fix-item row-title">合计</div>
      </div>
      <div class="right">
        <div class="right-item" v-for="(item, index) in listData" :key="index">
          <div class="top fix-item">{{ item.date }}</div>
          <div class="fix-item">{{ item.appCount }}</div>
          <div class="fix-item">{{ item.webCount }}</div>
          <div class="fix-item">{{ item.dingCount }}</div>
          <div class="fix-item">{{ item.dingWebCount }}</div>
          <div class="fix-item">{{ item.totalCount }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Chart } from "@antv/g2";
import moment from "moment";
import butn from "@/components/button/index";
import { activityDay, exportDay } from "@/api/active";
import { ioRead } from "@/utils/common.js";
import TipLogo from "./tipLogo.vue";

export default {
  props: ["deptLevelCodes", "userType"],
  components: {
    butn,
    TipLogo,
  },
  watch: {
    deptLevelCodes: {
      handler(val, oldVal) {
        console.log(val, oldVal);
        if (this.userType === -1) {
          if (val) {
            this.qparas.deptLevelCodes = val;
            this.query();
          }
        } else {
          this.qparas.deptLevelCodes = val || [];
          this.query();
        }
      },
      immediate: true,
    },
  },

  data() {
    return {
      size: "small",
      actDay: 1,
      nowDay: moment(new Date()).format("YYYY-MM-DD"),
      sevenDay: moment(new Date() - 144 * 60 * 60 * 1000).format("YYYY-MM-DD"),
      ssDay: moment(new Date() - 696 * 60 * 60 * 1000).format("YYYY-MM-DD"),
      filters: {},
      dateArea: [],
      pickerMinDate: null,
      listData: [],
      chartData: [],
      chart: null,
      pickerOptions1: {
        onPick: ({ maxDate, minDate }) => {
          this.pickerMinDate = minDate.getTime();
          if (maxDate) {
            this.pickerMinDate = "";
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            const day30 = (30 - 1) * 24 * 3600 * 1000;
            let maxTime = this.pickerMinDate + day30;
            let minTime = this.pickerMinDate - day30;
            if (maxTime > new Date()) {
              maxTime = new Date();
            }
            return time.getTime() > maxTime || time.getTime() < minTime;
          }
          return time.getTime() > Date.now();
        },
      },
      qparas: {
        deptLevelCodes: [],
        start: null,
        end: null,
      },
      tipList: [
        { name: "APP", color: "#BE37F4" },
        { name: "web门户", color: "#0083F4" },
        { name: "浙政钉小程序", color: "#48D68D" },
        { name: "浙政钉PC端", color: "#FBDC03" },
      ],
    };
  },
  mounted() {
    this.drawChart(this.chartData);
  },
  methods: {
    drawChart(data) {
      const chart = new Chart({
        container: "day-active",
        autoFit: true,
        height: 300,
      });
      chart.data(data);
      chart.scale({
        date: {
          // range: [0, 1],
        },
        count: {
          min: 0,
          nice: true,
        },
      });
      chart.tooltip({
        showCrosshairs: true,
        shared: true,
      });
      chart.axis("count");
      chart.legend(false);
      chart
        .line()
        .position("date*count")
        .color("type")
        .shape("smooth");
      chart
        .point()
        .position("date*count")
        .color("type")
        .shape("circle");
      chart.render();
      this.chart = chart;
    },
    dayChange(val) {
      this.actDay = val;
      this.query();
    },
    query() {
      switch (this.actDay) {
        case 1:
          this.qparas.start = this.sevenDay;
          this.qparas.end = this.nowDay;
          break;
        case 2:
          this.qparas.start = this.ssDay;
          this.qparas.end = this.nowDay;
          break;
        case 3:
          this.qparas.start = this.dateArea[0];
          this.qparas.end = this.dateArea[1];
          break;
        default:
          break;
      }
      activityDay(this.qparas).then(({ code, data }) => {
        if (code === 0) {
          this.listData = data;
          let rl = [];
          data.forEach((x) => {
            let o = { date: x.date, type: "APP", count: x.appCount};
            rl.push(o);
            let q = { date: x.date, type: "web门户", count: x.webCount};
            rl.push(q);
            let p = { date: x.date, type: "浙政钉小程序", count: x.dingCount};
            rl.push(p);
            let s = { date: x.date, type: "浙政钉PC端", count: x.dingWebCount};
            rl.push(s);
          });
          this.chartData = rl;
          this.changeChart(rl);
        }
      });
    },
    changeChart(data) {
      this.chart.clear();
      this.chart.data(data);
      this.chart.scale({
        date: {
          // range: [0, 1],
        },
        count: {
          min: 0,
          nice: true,
        },
      });
      this.chart.tooltip({
        showCrosshairs: true,
        shared: true,
      });
      this.chart.axis("count");
      this.chart.legend(false);
      this.chart
        .line()
        .position("date*count")
        .color("type", (type) => {
          let color = this.tipList.find((x) => x.name === type).color
          return color
        })
        .shape("smooth");
      this.chart.render();
    },
    initData() {
      if (!this.dateArea || this.dateArea.length < 2) {
        this.$message.error("请选择日期范围！");
      } else {
        this.qparas.start = this.dateArea[0];
        this.qparas.end = this.dateArea[1];
        this.dayChange(3);
      }
    },
    // 导出
    exportTable() {
      switch (this.actDay) {
        case 1:
          this.qparas.start = this.sevenDay;
          this.qparas.end = this.nowDay;
          break;
        case 2:
          this.qparas.start = this.ssDay;
          this.qparas.end = this.nowDay;
          break;
        case 3:
          this.qparas.start = this.dateArea[0];
          this.qparas.end = this.dateArea[1];
          break;
        default:
          break;
      }
      exportDay(this.qparas).then((res) => {
        ioRead(res);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.cat-name {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #343c4a;
  padding: 30px 0 24px 0;
  .info-text {
    font-size: 12px;
  }
}
.search-header {
  display: flex;
  justify-content: space-between;
}

.fil-view {
  display: flex;
  .sel-btn {
    min-width: 73px !important;
    height: 28px;
    line-height: 28px;
    background: #ffffff;
    border: 1px solid #d7dbe0;
    border-radius: 5px;
    margin-right: 8px;
    text-align: center;
    cursor: pointer;
    &.active {
      background: rgba(58, 133, 255, 0.21);
      border: 1px solid #3a85ff;
    }
  }
}
.logo-tip {
  min-width: 475px;
  display: flex;
  align-items: center;
  height: 35px;
  .tip-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    .tip-char {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #51627d;
      margin-right: 24px;
      margin-left: 3px;
    }
  }
}
.table-view {
  display: flex;
  .fix-item {
    width: 90px;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }
  .row-title {
    width: 180px;
  }
  .top {
    background: #dce7fa;
    font-weight: 500;
    color: #343c4a;
  }
  .left {
  }
  .right {
    flex: 1;
    display: flex;
    overflow: auto;
  }
}
.mar-30 {
  margin: 30px 0;
}
</style>
